module.exports = "td{\r\n    border: 1px solid #ddd;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/planning/statutory-clearances/statutory-clearances-grid/statutory-clearances-grid.component.css
// module id = ./src/app/planning/statutory-clearances/statutory-clearances-grid/statutory-clearances-grid.component.css
// module chunks = main